import { AssetType, AssetTypeRepository } from '@telespot/domain';

export interface ListAssetTypesInput {
  searchTerm?: string;
  limit?: number;
  lastItemName?: string;
}

export interface ListAssetTypesOutput {
  id: string;
  name: string;
  type: 'image' | 'video' | 'text' | 'audio';
  deviceTypeIds: string[];
  supportedDevices: number;
}

export interface IListAssetTypesQuery {
  /**
   * Lists asset types ordered by name, paginated by `lastItemName` cursor.
   * Each item is projected to a flat shape including the count of supported devices.
   * Repository errors propagate so the caller's pagination effect can surface them.
   */
  execute(input: ListAssetTypesInput): Promise<ListAssetTypesOutput[]>;
}

export class ListAssetTypesQuery implements IListAssetTypesQuery {
  constructor(private readonly assetTypeRepository: AssetTypeRepository) {}

  public async execute(input: ListAssetTypesInput): Promise<ListAssetTypesOutput[]> {
    const assetTypes = await this.assetTypeRepository.getAll(input.searchTerm, input.limit, input.lastItemName);
    return assetTypes.map((assetType: AssetType) => {
      const deviceTypeIds = [...assetType.deviceTypeIds];
      return {
        id: assetType.id,
        name: assetType.name,
        type: assetType.type,
        deviceTypeIds,
        supportedDevices: deviceTypeIds.length,
      };
    });
  }
}
